import React from "react";
import { RiDeleteBin6Fill } from "react-icons/ri";

const AddApliance = ({id, quantity}) => {
	return (
		<div className="appliance__container">
			<span className="item__id">{id}</span>
			<p className="item__details">Electric cooker .  200W 12hrsday</p>
			<div className="quantity">{quantity}</div>
			<div className="remoove__item"><RiDeleteBin6Fill /></div>
		</div>
	);
};

export default AddApliance;
